import React from 'react';
import './ModalContentMessage.css';
const ModalContentMessage = ({onCLickButton,message}) => (
    <div className="modalcontentmessage">
        <p>{message}</p>
        <button onClick={onCLickButton} >OK</button>
    </div>
);

export default ModalContentMessage;


// WEBPACK FOOTER //
// ./src/components/ModalContentMessage/index.js